"use client";

import BlokWrap from "@/components/bloks/BlokWrap";
import type { BlokDisplayCards } from "@/storyblok";
import { type BlokProps, StoryblokComponent } from "@frend-digital/storyblok";
import styles from "./DisplayCards.module.css";
import { useGlobalAnimationObserver } from "@/hooks/useGlobalAnimationObserver";

export const DisplayCardsBlok = ({ blok, preview, index = 0 }: BlokProps<BlokDisplayCards>) => {
	return (
		<BlokWrap editable={blok} asChild>
			<div data-animate className={styles.wrapper}>
				{blok.title && (
					<h2 data-fade className={styles.title}>
						{blok.title}
					</h2>
				)}
				<div data-fade className={styles.content}>
					{blok.cards?.map((card) => (
						<div key={card._uid} className={styles.column}>
							<StoryblokComponent
								blok={card}
								index={index}
								preview={preview}
								displayBelow={blok.displayBelow}
							/>
						</div>
					))}
				</div>
			</div>
		</BlokWrap>
	);
};
